import { typeDisscount } from '../constants/options.constant';

export const prefixHandle = (disscount) => {
	if (disscount === typeDisscount.percentage) {
		return '%';
	}
	if (disscount === typeDisscount.permanent) {
		return '$';
	}
	return null;
};
